module.exports = __webpack_public_path__ + "static/media/filmen.4b76e2be.png";